import { useState } from "react";
import {
  Foundation,
  Home,
  Map,
  AddBusiness,
  Logout,
  Engineering,
  Summarize,
  Report,
  SettingsAccessibility,
  AddComment,
} from "@mui/icons-material";
import RootLayout from "../RootLayout";
import "../no-print.css";

const designMenuItems = [
  { key: "home", to: "/", title: "Home", iconClass: <Home /> },
  {
    key: "GROUP",
    iconClass: <AddBusiness />,
    title: "Building Permit",
    detail: [
      {
        key: "registerBPrequest",
        to: "/registerBPrequest",
        title: "Register",
        iconClass: <AddBusiness />,
      },
      {
        key: "listBPermit",
        to: "/listBPermit",
        title: "List",
        iconClass: <Summarize />,
      },
      {
        key: "registerComment",
        to: "/registerComment",
        title: "Comment",
        iconClass: <AddComment />,
      },
    ],
  },
  {
    key: "GROUP",
    iconClass: <Foundation />,
    title: "Occupancy Permit",
    detail: [
      {
        key: "registerOPrequest",
        to: "/registerOPrequest",
        title: "Register",
        iconClass: <Foundation />,
      },
      {
        key: "listOPermit",
        to: "/listOPermit",
        title: "List",
        iconClass: <Summarize />,
      },
      // {
      //   key: "registerComment",
      //   to: "/registerCommentocc",
      //   title: "Comment",
      //   iconClass: <AddComment />,
      // },
    ],
  },
  { key: "viewMap", to: "/viewMap", title: "View Map", iconClass: <Map /> },
  {
    key: "GROUP",
    iconClass: <Engineering />,
    title: "Manage",
    detail: [
      {
        key: "Consultants",
        to: "/manageConsultants",
        title: "Consultants",
        iconClass: <Engineering />,
      },
      {
        key: "Contractors",
        to: "/manageContractors",
        title: "Contractors",
        iconClass: <Engineering />,
      },
    ],
  },

  {
    key: "GROUP",
    iconClass: <Engineering />,
    title: "Generate",
    detail: [
      {
        key: "generatebuildingpermit",
        to: "/generatebuildingpermit",
        title: "Bulding Permit",
        iconClass: <Report />,
      },
     
      {
       key: "generateoccupancygpermit",
       to: "/generateoccupancypermit",
       title: "occupancy Permit",
       iconClass: <Report sx={{ mr: 0.5 }} />, // Reduced margin
     },
      
    ],
  },
  {
    key: "GROUP",
    iconClass: <Engineering />,
    title: "Report",
    detail: [
      {
        key: "designReports",
        to: "/designReports",
        title: "Design Permit ",
        iconClass: <Report />,
      },
     
      {
        key: "designReports",
        to: "/occupancyReports",
        title: "Occupancy Permit",
        iconClass: <Report />,
      },
      
    ],
  },
  
  {
    key: "myPreference",
    to: "/myPreference",
    title: "Preferences",
    iconClass: <SettingsAccessibility />,
  },
  { key: "logout", to: "/logout", title: "Logout", iconClass: <Logout /> },
];
export default function DesignAndConstructionLayout() {
  const [open, setOpen] = useState(true);
  const [showProfile, setShowProfile] = useState(true);
  return (
    <RootLayout
      department="Design Management"
      open={open}
      setOpen={setOpen}
      showProfile={showProfile}
      setShowProfile={setShowProfile}
      menuList={designMenuItems}
    />
  );
}
